<template>
  <div>
    <v-form>
      <p class="mb-3">
        Which of the following figures denotes the correct curved arrow notation for the formation
        of the enolate ion in an aldol condensation?
      </p>

      <v-radio-group v-model="inputs.studentAnswer" :disabled="!allowEditing" class="mb-0 pl-6">
        <v-radio
          v-for="option in optionsShuffled"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <img :src="option.img" alt="" :style="option.width" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUCI_51LPPL7_Q3',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
      options: [
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q3_optionA.png'),
          value: 'a',
          width: 'max-width: 173px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q3_optionB.png'),
          value: 'b',
          width: 'max-width: 161px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q3_optionC.png'),
          value: 'c',
          width: 'max-width: 213px',
        },
        {
          img: prefixPublicAsset('/img/assignments/UCI_Prelab7_Q3_optionD.png'),
          value: 'd',
          width: 'max-width: 193px',
        },
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
  },
};
</script>
